import React, { useState, useRef, useEffect } from 'react';
import HeaderItem from '../HeaderItem';
import { HelpWrapper, HelpTrigger, HelpDropdown, HelpItem, HelpDivider } from './Help.styles';

const HELP_DROPDOWN_ID = 'help-dropdown-menu';

const HelpComponent: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const triggerRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent): void => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        const handleKeyDown = (event: KeyboardEvent): void => {
            if (event.key === 'Escape') {
                setIsOpen(false);
                triggerRef.current?.focus();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen]);

    const handleToggle = (): void => {
        setIsOpen((prev) => !prev);
    };

    const handleItemClick = (): void => {
        setIsOpen(false);
    };

    return (
        <HelpWrapper ref={wrapperRef}>
            <HelpTrigger
                ref={triggerRef}
                type="button"
                aria-haspopup="menu"
                aria-expanded={isOpen}
                aria-controls={HELP_DROPDOWN_ID}
                onClick={handleToggle}
            >
                <HeaderItem title={'Help'} iconName={'question-circle'} path={''} />
            </HelpTrigger>

            {isOpen && (
                <HelpDropdown id={HELP_DROPDOWN_ID} role="menu">
                    <HelpItem href="/ORCA web user guide version 1.12.pdf" target="_blank" role="menuitem" onClick={handleItemClick}>
                        Technical User Guide
                    </HelpItem>
                    <HelpDivider role="separator" aria-hidden="true" />
                    <HelpItem href="/reporting-workflow-and-verification.html" target="_blank" role="menuitem" onClick={handleItemClick}>
                        Reporting Guide and Best Practices
                    </HelpItem>
                </HelpDropdown>
            )}
        </HelpWrapper>
    );
};

export default HelpComponent;
